import React, { useState, useEffect } from 'react';
import {instance, instance2} from '../../utils/axiosInstance'
import { ReactComponent as VerticalLine } from '../../img/verticalline.svg'
import { ReactComponent as MagnificationLogo } from '../../img/magnificationlensicon.svg'
import { formatNumber } from "../../numberingformat"; // Ensure formatNumber works for formatting
import { useLocation } from 'react-router-dom';
import { ReactComponent as BackButton } from "../../img/bacbuttonicon.svg";



export default function PriceUploadTableDetail(){
    
  const [data, setData] = useState([]); // ✅ Ensure data is an array
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id"); // Get the ID from URL
    const [searchOverlayQuery, setSearchOverlayQuery] = useState(""); // State for search input
            const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
            const itemsPerPage = 10; // Number of items per page

console.log("id", id)

  const filteredData = data
? data.filter((item) => {
    const formattedDate = item.createdat
      ? new Date(item.createdat).toLocaleDateString("id-ID", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })
      : "";

    return (
      (item.ingredient_name &&
        item.ingredient_name
          .toLowerCase()
          .includes(searchOverlayQuery.toLowerCase())) ||
      (item.price &&
        item.price.toString().toLowerCase().includes(searchOverlayQuery.toLowerCase())) ||
      formattedDate.toLowerCase().includes(searchOverlayQuery.toLowerCase())
    );
  })
: [];
    
  useEffect(() => {
          const fetchData = async () => {
            try {
              const response = await instance2.get(`price_upload_detail/${id}`); // Use instance2 for the API call
              console.log("API Response:", response.data); // 🔍 Debug API response
        
              setData(response.data); // Set data from Axios response
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          };
        
          fetchData();
        }, []);

 // Pagination logic
 const totalPages = Math.ceil(filteredData.length / itemsPerPage);
 const paginatedData = filteredData.slice(
   (currentPage - 1) * itemsPerPage,
   currentPage * itemsPerPage
 );

 const handlePreviousPage = () => {
   if (currentPage > 1) setCurrentPage(currentPage - 1);
 };

 const handleNextPage = () => {
   if (currentPage < totalPages) setCurrentPage(currentPage + 1);
 };

 // Determine which page numbers to show
 let pageNumbers = [];
 const maxVisiblePages = 5;

 if (totalPages <= maxVisiblePages) {
   pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
 } else {
   if (currentPage <= 3) {
     // Near the beginning
     pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
   } else if (currentPage >= totalPages - 2) {
     // Near the end
     pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
   } else {
     // In the middle
     pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
   }
 }

    return(
        <div className="p-4">
    <div className="">
        <div className="flex flex-row gap-4 items-center">
                              <div className="bg-white p-2 rounded-full cursor-pointer"
                                  onClick={() => window.history.back()}>
                              <BackButton 
                              className="rotate-180 text-black" />
                              </div>
                              <div className='flex flex-col'>
            <h1 className="block text-black text-xl sm:text-2xl font-medium">{`Update Harga`}</h1>
              <h1 className="block text-black text-xl sm:text-2xl font-medium">{`${data[0]?.supplier_name || `Pemasok`}`}</h1>
              <h1 className="block text-black text-md sm:text-xl font-medium">{`${data[0]?.createdat
                      ? new Date(data[0]?.createdat).toLocaleDateString("id-ID", {
                          year: "numeric",
                          month: "long",
                          day: "2-digit",
                        })
                      : "-"}`}</h1>
            </div>
            </div>
      
      {/* Overlay Header */}
      {/* <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold">Detail Data</h2>
        <PlusIcon
          className="text-merah-no hover:text-merah-hover cursor-pointer transform rotate-45"
          onClick={closeOverlay}
        />
      </div> */}

      {/* Overlay Search Bar */}
      <div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2 w-full md:w-auto">
        <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center w-full md:w-auto justify-start">
          <MagnificationLogo />
          <VerticalLine className="mx-1" />
          <input
            type="text"
            placeholder="Telusuri data berdasarkan nama bahan, harga, atau tanggal"
            className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-sm"
            style={{
              width: `${"Telusuri data berdasarkan nama bahan, harga, atau tanggal".length}ch`,
            }}
            value={searchOverlayQuery} // Controlled input
            onChange={(e) => setSearchOverlayQuery(e.target.value)} // Update search query
          />
        </div>
        {/* <div className="text-gray-400">
          <FilterLogo />
        </div> */}
      </div>

      {/* Overlay Table */}
      <table className="table-fixed w-full border-collapse text-left relative">
        <thead>
          <tr className="bg-white">
            <th className="border-b px-4 py-2 cursor-pointer rounded-tl-[15px] w-[3%]">No</th>
            <th className="border-b px-4 py-2 cursor-pointer">Nama Bahan</th>
            <th className="border-b px-4 py-2 cursor-pointer">Harga</th>
            <th className="border-b px-4 py-2 cursor-pointer">Beda Harga dengan Sebelumnya</th>
            {/* <th className="border-b px-4 py-2 cursor-pointer rounded-tr-[15px]">Update Terakhir</th> */}
          </tr>
        </thead>
        <tbody>
          {filteredData.map((detail, index) => (
            <tr
            key={detail.id}
            className={`hover:bg-gray-200  odd:bg-transparent even:bg-white`}
          >
              <td className="border-b border-gray-300 px-4 py-2">{index+1}</td>
              <td className="border-b border-gray-300 px-4 py-2">
                {detail.ingredient_name}
              </td>
              <td className="border-b border-gray-300 px-4 py-2">{formatNumber(detail.price)}</td>
              <td className="border-b border-gray-300 px-4 py-2 text-center">{detail.price_diff > 0 ? "+" && detail.price_diff : detail.price_diff}</td>
              {/* <td className="border-b border-gray-300 px-4 py-2">
                {detail.createdat
                  ? new Date(detail.createdat).toLocaleDateString("id-ID", {
                      year: "numeric",
                      month: "long",
                      day: "2-digit",
                    })
                  : "-"}
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
      
      <div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
    </div>
  </div>
    )
}